import Navi from '../../component/navi/Navi';

import { isIndexInLoop, getLoopedLastIndex, getReverseLoopedFirstIndex } from '../../utils/util';

class DesktopPaginationNavi {
  constructor(options) {
    const _ = this;
    if (!options) return;

    _.option = $.extend(true, {
      wrap: null,
      clickCallback: null,
      firstIndex: 1,
      global: window
    }, options);

    _.wrap = $(_.option.wrap);

    _.naviWrap = $('> .btns', _.wrap);

    _.navi = null;
    _.naviListItems = [];

    _.prevBtn = null;
    _.nextBtn = null;

    _.edgeBtnsIndex = {
      left: 0,
      right: 0
    };

    _.global = _.option.global || window;

    /*
     * const
     */
    _.DISPLAY_BTN_NUM = 4;

    _.DISABLE_PREVNEXT_BTN_INTERVAL = 500;
  }

  init() {
    this.setInstance();
  }

  setInstance() {
    const _ = this;

    if (_.wrap.length <= 0) return;

    // set list items width, position.
    _.naviListItems = $('li', _.naviWrap);

    // set left, right edge btn index.
    if (_.naviListItems.length > _.DISPLAY_BTN_NUM) {
      _.edgeBtnsIndex = {
        left: _.option.firstIndex,
        right: getLoopedLastIndex(_.naviListItems.length, _.DISPLAY_BTN_NUM, _.option.firstIndex)
      };
    }

    _.setNavi();
    _.setPrevNextBtn();
    _.arrangeNaviListItems();

    $(_.global).on('resize.ui.desktoppaginationnavi', $.proxy(_.resize, _));
    _.resize();
  }

  setNavi() {
    const _ = this;

    _.navi = new Navi({
      btns: $('.btns li a', _.wrap),

      clickCallback: function (obj) {
        if (_.option.clickCallback) _.option.clickCallback.call(null, obj);
      },

      activateCallback: function (obj) {
        _.activateNaviBtn(obj.index);
      }
    });
    _.navi.init();
  }

  setPrevNextBtn() {
    const _ = this;

    _.prevBtn = $('.btn-prev', _.wrap);
    _.nextBtn = $('.btn-next', _.wrap);

    if (_.naviListItems.length <= _.DISPLAY_BTN_NUM) {
      _.prevBtn.hide();
      _.nextBtn.hide();
    } else {
      _.prevBtn.show();
      _.nextBtn.show();
    }

    _.prevBtn.on('click.ui.desktoppaginationnavi', function (evt) {
      evt.preventDefault();

      let index = _.navi.getActivatedIndex() - 1;
      if (index <= 0) index = _.navi.getBtns().length;

      $(_).trigger({
        type: DesktopPaginationNavi.CLICK_PREVNEXT_BTN,
        direction: 'prev',
        index: index
      });

      _.disablePrevNextBtnAtMoment(_.prevBtn, _.DISABLE_PREVNEXT_BTN_INTERVAL);
    });

    _.nextBtn.on('click.ui.desktoppaginationnavi', function (evt) {
      evt.preventDefault();

      let index = _.navi.getActivatedIndex() + 1;
      if (index > _.navi.getBtns().length) index = 1;

      $(_).trigger({
        type: DesktopPaginationNavi.CLICK_PREVNEXT_BTN,
        direction: 'next',
        index: index
      });

      _.disablePrevNextBtnAtMoment(_.nextBtn, _.DISABLE_PREVNEXT_BTN_INTERVAL);
    });
  }

  disablePrevNextBtnAtMoment(btn, interval) {
    btn.prop('disabled', true);

    window.setTimeout(function() {
      btn.prop('disabled', false);
    }, interval);
  }

  activateNaviBtn(index) {
    const _ = this;

    let btns = $(_.navi.getBtns()),
      btn = $(_.navi.getBtn(index));

    btns.removeClass('on');
    btn.addClass('on');
  }

  arrangeNaviListItems() {
    const _ = this,
      listItemWidth = _.getNaviListItemWidth(_.naviListItems.length);

    _.setNaviListItemsWidth(listItemWidth);
    _.setNaviListItemsPosition(_.naviListItems, listItemWidth);
  }

  setNaviListItemsWidth(itemWidth) {
    const _ = this;
    if (_.naviListItems.length) _.naviListItems.width(itemWidth);
  }

  setNaviListItemsPosition(listItems, itemWidth) {
    const _ = this;
    if (listItems.length <= 0) return;

    // set visible listItems position.
    if (listItems.length <= _.DISPLAY_BTN_NUM) {
      for (let i = 0; i < listItems.length; i++) {
        let listItem = $(listItems[i]);
        tram(listItem).set({x: i * itemWidth});
      }

    } else {
      // show only visible btns.
      $(listItems).hide();

      let index = _.edgeBtnsIndex.left;
      for (let i = 0; i < _.DISPLAY_BTN_NUM; i++) {
        let listItem = $(listItems[index - 1]);

        index++;
        if (_.naviListItems.length < index) index = 1;

        listItem.show();
        tram(listItem).set({x: i * itemWidth});
      }
    }
  }

  getNaviListItemWidth(itemLength) {
    const _ = this,
      width = _.naviWrap.width();

    if (itemLength <= 1) {
      return width;

    } else if (itemLength <= _.DISPLAY_BTN_NUM) {
      return width / itemLength;
    }

    return width / _.DISPLAY_BTN_NUM;
  }

  resize(evt) {
    const _ = this;
    _.arrangeNaviListItems();
  }

  destroy(obj) {
    const _ = this;

    $(_.global).off('resize.ui.desktoppaginationnavi');

    if (_.navi) _.navi.destroy();
    _.navi = null;

    _.naviListItems = [];

    _.prevBtn.off('click.ui.desktoppaginationnavi');
    _.prevBtn = null;

    _.nextBtn.off('click.ui.desktoppaginationnavi');
    _.nextBtn = null;
  }

  /*
   * public methods
   */
  activate(index) {
    const _ = this;
    if (_.navi) _.navi.activate(index);
  }

  getActivatedIndex() {
    const _ = this;
    if (_.navi) return _.navi.getActivatedIndex();
    return 0;
  }

  switchBtns(direction, index) {
    const _ = this;

    if (_.naviListItems.length <= _.DISPLAY_BTN_NUM) return;
    if (!direction) return;
    if (isIndexInLoop(_.naviListItems.length, _.DISPLAY_BTN_NUM, _.edgeBtnsIndex.left, index)) return;

    const btnsWrap = $('.btns', _.wrap),
      btns = _.navi.getBtns(),
      itemWidth = _.getNaviListItemWidth(btns.length);

    let slideBtnWrapStartX = 0;

    switch (direction) {
      case 'prev' :
        _.edgeBtnsIndex = {
          left: getReverseLoopedFirstIndex(_.naviListItems.length, _.DISPLAY_BTN_NUM, index),
          right: index
        };

        slideBtnWrapStartX = -_.global.innerWidth;
        break;

      case 'next' :
        _.edgeBtnsIndex = {
          left: index,
          right: getLoopedLastIndex(_.naviListItems.length, _.DISPLAY_BTN_NUM, index)
        };

        slideBtnWrapStartX = _.global.innerWidth;
        break;
    }

    _.setNaviListItemsWidth(itemWidth);
    _.setNaviListItemsPosition(_.naviListItems, itemWidth);

    tram(btnsWrap)
      .stop({x: true})
      .set({x: slideBtnWrapStartX})
      .add('transform 0.5s ease-out-expo')
      .start({x: 0})
      .then(function () {
      });
  }
}
DesktopPaginationNavi.CLICK_PREVNEXT_BTN = 'CLICK_PREVNEXT_BTN';

export default DesktopPaginationNavi;


// WEBPACK FOOTER //
// ./_src/js/main/promotionBanner/DesktopPaginationNavi.js